import _regeneratorRuntime from "/home/robson/react-app/artefield-landingpage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/robson/react-app/artefield-landingpage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/robson/react-app/artefield-landingpage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useRef } from "react"; // MAIN DATA

export var data = {
  widthResponsive: 800 // USE INTERVAL

};
export function useInterval(callback, delay) {
  var savedCallback = useRef(); // Remember the latest function.

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
} // WINDOW WIDTH

export function useWindowWidth() {
  var _useState = useState(window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      return setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });
  return width;
}
export function fetchAsync(_x, _x2, _x3) {
  return _fetchAsync.apply(this, arguments);
}

function _fetchAsync() {
  _fetchAsync = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, method, data) {
    var response, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            response = {};

            if (!(typeof data === "undefined")) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return fetch(url, {
              method: method,
              headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "q=0.8;application/json;q=0.9"
              }),
              mode: "no-cors"
            });

          case 4:
            response = _context.sent;
            _context.next = 10;
            break;

          case 7:
            _context.next = 9;
            return fetch(url, {
              method: method,
              headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "q=0.8;application/json;q=0.9"
              }),
              body: data,
              mode: "no-cors"
            });

          case 9:
            response = _context.sent;

          case 10:
            _context.next = 12;
            return response.json();

          case 12:
            body = _context.sent;
            return _context.abrupt("return", body);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchAsync.apply(this, arguments);
}